import { mapGetters } from 'vuex'

export default {
  computed: {
    // Note: If you updated your Vuex getter names in the store, 
    // update these strings to match (e.g., 'currentUser', 'userStatus')
    ...mapGetters([
      'selfUserInfoGetters', 
      'selfUserStatusGetters'
    ]),

    currentUser() {
      return this.selfUserInfoGetters.data || {}
    },

    selfUserId() {
      return this.currentUser.id || localStorage.getItem('LoginedUserID')
    },

    selfUserStatus() {
      return this.selfUserStatusGetters || {}
    },

    isStaffUser() {
      return !!this.currentUser.is_staff
    },

    hasProPayment() {
      return !!this.currentUser.pro_payment
    },

    hasAutoPayment() {
      return !!this.currentUser.auto_payment
    }
  }
}